/* Cove Pret v2 — theme.js */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;

  /* ---------- Loader ---------- */
  var loader = document.querySelector('[data-loader]');
  var loaderWord = loader && loader.querySelector('.loader__word');
  function animateLoaderWord() {
    if (loaderWord) { loaderWord.style.transition = 'opacity 1s ease, letter-spacing 1.4s ease'; requestAnimationFrame(function () { loaderWord.style.opacity = '1'; loaderWord.style.letterSpacing = '.55em'; }); }
  }
  function hideLoader() {
    if (!loader || loader.classList.contains('done')) return;
    loader.style.transition = 'opacity .6s ease';
    loader.style.opacity = '0';
    loader.classList.add('done');
    setTimeout(function () { loader.style.display = 'none'; }, 650);
  }

  /* ---------- Lenis smooth scroll ---------- */
  var lenis = null;
  function initLenis() {
    if (body.hasAttribute('data-lenis') && window.Lenis && !reduce) {
      lenis = new window.Lenis({ duration: 1.1, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); } });
      function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      if (window.ScrollTrigger) lenis.on('scroll', window.ScrollTrigger.update);
    }
  }

  /* ---------- GSAP reveals + hero ---------- */
  function initGsap() {
    if (!window.gsap || reduce) { document.querySelectorAll('.reveal').forEach(function (e) { e.classList.add('in'); }); return; }
    var gsap = window.gsap;
    if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

    var heroItems = document.querySelectorAll('.hero__content > *');
    if (heroItems.length) {
      gsap.set(heroItems, { y: 24, opacity: 0 });
      gsap.to(heroItems, { y: 0, opacity: 1, duration: 1, stagger: 0.14, ease: 'power3.out', delay: 0.25 });
    }
    var heroMedia = document.querySelector('.hero__media');
    if (heroMedia && window.ScrollTrigger) {
      gsap.to(heroMedia, { yPercent: 18, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
    }
    if (window.ScrollTrigger) {
      document.querySelectorAll('.reveal').forEach(function (el) {
        window.ScrollTrigger.create({ trigger: el, start: 'top 86%', onEnter: function () { el.classList.add('in'); } });
      });
    } else {
      document.querySelectorAll('.reveal').forEach(function (e) { e.classList.add('in'); });
    }
  }

  /* ---------- Cursor ---------- */
  function initCursor() {
    if (!body.hasAttribute('data-cursor') || reduce) return;
    var dot = document.querySelector('[data-cursor-dot]');
    if (!dot) return;
    var x = 0, y = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; });
    function loop() { cx += (x - cx) * 0.18; cy += (y - cy) * 0.18; dot.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); }
    loop();
    document.addEventListener('mouseover', function (e) { if (e.target.closest('a,button,.scard,.card,.swatch')) dot.classList.add('hover'); });
    document.addEventListener('mouseout', function (e) { if (e.target.closest('a,button,.scard,.card,.swatch')) dot.classList.remove('hover'); });
  }

  /* ---------- Header glass ---------- */
  function initHeader() {
    var header = document.querySelector('.header');
    if (!header) return;
    function onScroll() { if (window.scrollY > 40) header.classList.add('glass'); else header.classList.remove('glass'); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.add('open'); }); });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.remove('open'); }); });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-track]');
      var slides = car.querySelectorAll('[data-slide]');
      var prev = car.querySelector('[data-prev]');
      var next = car.querySelector('[data-next]');
      var dots = car.querySelectorAll('[data-dot]');
      if (!track || slides.length < 2) return;
      function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
      function upd() { var i = cur(); dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); }); if (prev) prev.hidden = i === 0; if (next) next.hidden = i === slides.length - 1; }
      prev && prev.addEventListener('click', function () { go(cur() - 1); });
      next && next.addEventListener('click', function () { go(cur() + 1); });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  /* ---------- Wishlist ---------- */
  function initWishlist() {
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        btn.classList.toggle('on');
        btn.textContent = btn.classList.contains('on') ? '\u2665' : '\u2661';
      });
    });
  }

  /* ---------- Quick add ---------- */
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-variant');
        if (!id) { window.location = btn.getAttribute('data-url'); return; }
        var label = btn.textContent;
        btn.textContent = 'Adding\u2026';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
          .then(function (r) { return r.json(); })
          .then(function () { btn.textContent = 'Added \u2713'; setTimeout(function () { btn.textContent = label; }, 1600); })
          .catch(function () { window.location = btn.getAttribute('data-url'); });
      });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var form = document.getElementById('addform');
    if (!form) return;
    var select = form.querySelector('[data-variant-select]');
    var addBtn = form.querySelector('.pdp__add');
    var priceEl = document.querySelector('[data-price]');
    var chosen = {};
    function currentString() {
      var groups = form.querySelectorAll('[data-option-index]'); var parts = [];
      groups.forEach(function (g) { parts[g.getAttribute('data-option-index')] = chosen[g.getAttribute('data-option-index')]; });
      return parts.join(' / ');
    }
    function sync() {
      if (!select) return;
      var target = currentString();
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.getAttribute('data-options') === target) {
          select.value = opt.value;
          if (opt.disabled) { addBtn.setAttribute('disabled', ''); addBtn.textContent = 'Sold Out'; }
          else { addBtn.removeAttribute('disabled'); addBtn.textContent = 'Add to Cart'; }
          if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
        }
      });
    }
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var pressed = group.querySelector('[aria-pressed="true"]');
      chosen[idx] = pressed ? pressed.getAttribute('data-value') : group.querySelector('.swatch').getAttribute('data-value');
      group.querySelectorAll('.swatch').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('.swatch').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
          sw.setAttribute('aria-pressed', 'true'); chosen[idx] = sw.getAttribute('data-value'); sync();
        });
      });
    });
    var qtyInput = form.querySelector('[data-qty-input]');
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { var s = parseInt(b.getAttribute('data-qty'), 10); qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + s); });
    });
    sync();

    var sticky = document.querySelector('[data-sticky]');
    if (sticky) {
      window.addEventListener('scroll', function () { if (window.scrollY > 600) sticky.classList.add('show'); else sticky.classList.remove('show'); }, { passive: true });
      var sb = sticky.querySelector('button');
      sb && sb.addEventListener('click', function () { addBtn.click(); });
    }

    var lb = document.querySelector('[data-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('img');
      document.querySelectorAll('.pdp__gallery img').forEach(function (img) {
        img.addEventListener('click', function () { lbImg.src = img.src; lb.classList.add('open'); });
      });
      lb.addEventListener('click', function () { lb.classList.remove('open'); });
    }
  }

  /* ---------- Filters ---------- */
  function initFilters() {
    var bar = document.querySelector('[data-filters]');
    if (!bar) return;
    var selects = bar.querySelectorAll('select');
    var cards = document.querySelectorAll('[data-product-card]');
    var count = bar.querySelector('[data-count]');
    function apply() {
      var f = {};
      selects.forEach(function (s) { if (s.value) f[s.getAttribute('data-filter')] = s.value; });
      var shown = 0;
      cards.forEach(function (c) {
        var ok = true;
        for (var k in f) {
          if (k === 'price') {
            var p = parseFloat(c.getAttribute('data-price-amount') || '0');
            var range = f.price.split('-'); if (p < +range[0] || p > +range[1]) ok = false;
          } else {
            var vals = (c.getAttribute('data-' + k) || '').toLowerCase().split('|');
            if (vals.indexOf(f[k].toLowerCase()) === -1) ok = false;
          }
        }
        c.classList.toggle('hide', !ok); if (ok) shown++;
      });
      if (count) count.textContent = shown + ' pieces';
    }
    selects.forEach(function (s) { s.addEventListener('change', apply); });
  }

  function start() {
    animateLoaderWord();
    initLenis(); initGsap(); initCursor(); initHeader(); initDrawer();
    initCarousels(); initWishlist(); initQuickAdd(); initProduct(); initFilters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', hideLoader);
  setTimeout(hideLoader, 2600);
})();
